import { AnaColumn } from "../forms-template.service";

export const crmSendMessaggeGrid: AnaColumn[] = [

 {

    configuration: {
       service: 'crmSendMessageEditForm',

       api: 'messaggi',
       api_rest: true,
       masterKey: 'id',
       ncCol: 2

    },
    itemType: 'group',
    caption: 'Invia Messaggio',

    class: '',
    colCount: '1',
    data: [
        {
            type: 'campo',
            dataField: 'dataNotifica',
            disabled: false,
            colVisible: true,
            visible: true,
            editorType: "dxDateBox",
            dataType: 'date',
            format: "dd/MM/yyyy",
            caption: 'Data Notifica',
           
            disableOnUpdate: true,
            readonly: true,
            colWidth: 150,
            colAlignment: 'center',
    
        },
        {
            type: 'campo',
            dataField: 'messaggio',
            colVisible: true,
            visible: true,
            allowEditing: true,
            dataType: 'string',
            caption: 'Messagio',
            colAlignment: 'left',
        },
        {
            type: 'campo',
            dataField: 'CodSede',
            colVisible: false,
            visible: false,
            dataType: 'string',
            caption: 'Sede',
            colAlignment: 'center',
          },
          {
            type: 'campo',
            dataField: 'letto',
            readonly: true,
            colVisible: true,
            visible: true,
            dataType: 'boolean',
            caption: 'Letto',
            editorType: 'dxCheckBox',
            falseText: '1',
            trueText: '0',
            colWidth: 80,
            colAlignment: 'center',
            disableOnUpdate: true,
        },
        {
            type: 'campo',
            dataField: 'utenteCheHaLetto',
            colVisible: true,
            visible: true,
            allowEditing: true,
            dataType: 'string',
            caption: 'Letto Da',
            colAlignment: 'left',
            readonly: true,
            colWidth: 150,
            disableOnUpdate: true,
        },
        {
            type: 'campo',
            dataField: 'dataLettura',
            disabled: false,
            colVisible: true,
            visible: true,
            editorType: "dxDateBox",
            dataType: 'date',
            format: "dd/MM/yyyy",
            caption: 'Data Lettura',
            disableOnUpdate: true,
            readonly: true,
            colWidth: 150,
            colAlignment: 'center',
        },
      
    ]
 }


];

export const CrmSendMessaggeForm: AnaColumn[] = [

    {
        itemType: 'group',
        caption: 'Invia Messaggio', 
        class: '', 
        colCount: 1, 
        data: [
            {
                type: 'campo',
                dataField: 'messaggio',
                labelPosition: 'labelPositionTop',
                colVisible: true,
                class: 'crmSendMessaggeFormClass ',
                visible: true,
                dataType: 'string',
                caption: 'Invia Messaggio',
                nCol: 10, 
                button: {
                    name: 'invia',
                    hint: 'invia messaggio',
                    icon: 'bi bi-envelope',
                    event: '',

                }
              },
        ]
    }

]; 


export const crmSendMessageEditForm: AnaColumn[] = [


  {
    itemType: 'group',
    caption: 'Form Messaggio',
    class: '',
    colCount: '3',
    data: [
        {
            type: 'campo',
            dataField: 'dataNotifica',
            disabled: false,
            visible: true,
            editorType: "dxDateBox",
            dataType: 'date',
            format: "dd/MM/yyyy",
            caption: 'Data Notifica',
            disableOnUpdate: true,
            readonly: true,
            labelPosition: 'labelPositionTop',
            class: 'crmSendMessaggeeEditFormClass ',
            nCol: 3,
    
        },
        {
            type: 'campo',
            dataField: 'messaggio',
            visible: true,
            dataType: 'string',
            caption: 'Messagio',
            labelPosition: 'labelPositionTop',
            class: 'crmSendMessaggeeEditFormClass  ',
            nCol: 7,
        },
        { type: 'empty', colSpan: '3', },
        //---------------------------------------------------------------
        {
            type: 'campo',
            dataField: 'utenteCheHaLetto',
            visible: true,
            allowEditing: true,
            dataType: 'string',
            caption: 'Letto Da',
            labelPosition: 'labelPositionTop',
            class: 'crmSendMessaggeeEditFormClass',
            nCol: 5,
        },
        {
            type: 'campo',
            dataField: 'dataLettura',
            disabled: false,
            visible: true,
            editorType: "dxDateBox",
            dataType: 'date',
            format: "dd/MM/yyyy",
            caption: 'Data Lettura',
            labelPosition: 'labelPositionTop',
            class: 'crmSendMessaggeeEditFormClass ',
            disableOnUpdate: true,
            readonly: true,
            nCol: 5,
        },
    
   
      { type: 'empty', colSpan: '3', },
      //-------------------------------------------------------------------------
   
    ]
  },

];